import PropTypes from 'prop-types';

export default PropTypes.shape({
  from: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired
});
